import { NextSeo } from 'next-seo';

//screens
import { ProactiveLoadAudits } from '@/screens/Agents/ProactiveLoadAudits';

//data-helpers
import { JsonLd, Organization } from '@/datafiles/micro-data';

export default function ProactiveLoadAuditsPage() {
  return (
    <>
      <NextSeo
        nofollow={process.env.NOINDEX_FLAG === 'true'}
        noindex={process.env.NOINDEX_FLAG === 'true'}
        canonical="https://loadsmart.com/ai/proactive-load-audits/"
        title="Proactive Load Audits Agent | Loadsmart AI"
        description="Checks every load before pickup, flags at-risk transit while it can still be fixed, and audits every charge against the contracted rate and approved accessorial before it’s paid."
        openGraph={{
          url: 'https://loadsmart.com/ai/proactive-load-audits/',
        }}
      />
      <JsonLd data={Organization} />
      <ProactiveLoadAudits />
    </>
  );
}
